import { useEffect, useMemo } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import AutoScroll from 'embla-carousel-auto-scroll';
import Image from 'next/image';
import { useIsMobile } from '@/hooks/useIsMobile';
import { StaticImageData } from 'next/image';

interface ImageCarouselProps {
    duplicatedImages: StaticImageData[];
    className: string;
    direction: 'right' | 'left';
    speed?: number;
}

export const ImageCarousel = ({ duplicatedImages, className, direction, speed }: ImageCarouselProps) => {
    const isMobile = useIsMobile(767);
    const autoScrollOptions = useMemo(() => [
        AutoScroll({
            speed: speed ?? (isMobile ? 1.5 : 2),
            stopOnInteraction: false,
            stopOnMouseEnter: false,
            startDelay: 0,
            direction: direction === 'right' ? 'forward' : 'backward',
            playOnInit: true,
        })
    ], [direction, speed, isMobile]);

    const [emblaRef, emblaApi] = useEmblaCarousel(
        {
            loop: true,
            align: 'start',
            dragFree: true,
            containScroll: 'trimSnaps',
            slidesToScroll: 1,
        },
        autoScrollOptions
    );

    useEffect(() => {
        const autoScrollPlugin = emblaApi?.plugins()?.autoScroll;
        if (!autoScrollPlugin) return;

    }, [emblaApi]);
    return (
        <div style={{ overflow: 'hidden', width: '100vw' }} ref={emblaRef}>
            <div style={{ display: 'flex', gap: '0px', alignItems: 'flex-start', willChange: 'transform' }}>
                {duplicatedImages.map((image, index) => (
                    <img
                        key={index}
                        src={image.src}
                        alt="Team Scroll"
                        className={className}
                        sizes="(max-width: 768px) 50vw, 33vw"
                        style={{ willChange: 'transform' }}
                        // priority={index < 2}
                        loading={index < 4 ? 'eager' : 'lazy'}
                    />
                ))}
            </div>
        </div>
    )
}